import { InputField } from '@pickleballinc/react-ui';
import { forwardRef } from 'react';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
	disabled?: boolean;
	hasError?: boolean;
	hint?: string;
	label?: string;
	PrefixIcon?: () => React.ReactNode;
	SuffixIcon?: () => React.ReactNode;
	withDivider?: boolean;
	length?: number; // Add new length prop
	inputProps?: {
		className?: string;
		labelClassName?: string;
	};
}

export const Input = forwardRef<HTMLInputElement, InputFieldProps>(({ inputProps = {}, length, maxLength, SuffixIcon, ...props }, ref) => {
	// If length prop exists and maxLength exists but no SuffixIcon, create automatic counter
	const AutoSuffixIcon =
		length !== undefined && maxLength && !SuffixIcon
			? () => (
					<div className="text-xs text-gray-500">
						{length}/{maxLength}
					</div>
				)
			: SuffixIcon;

	return (
		<InputField
			focusColor="orange"
			ref={ref}
			inputProps={{
				labelClassName: 'text-sm',
				...inputProps
			}}
			SuffixIcon={AutoSuffixIcon}
			maxLength={maxLength}
			{...props}
		/>
	);
});

Input.displayName = 'Input';

export default Input;
